exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multiselect__tag {\n    background: #adadad;\n}\n.multiselect__tag-icon:after {\n    color: black\n}\n.multiselect__option--highlight {\n    background: #707070;\n}\n.swal2-container {\n    z-index: 999999999;\n}\n", ""]);

// exports
